import React from 'react'
import { IoPieChartOutline } from 'react-icons/io5';
import { MdOutlinePriceChange, MdOutlineSpeed } from "react-icons/md";

const MISummaryCard = ({ summaryKey, value, handleShowDrillDown, showDrops, headerSubText, subKey, subValue, turn , diamondKeys}) => {

    const ICON_HASH_FOR_SUMMERY = { 'Overhang': ['bi-safe2', 'sales-card'], '% Sold': ['bi-currency-dollar', 'revenue-card'], 'Price Change': ['bi-list-ol', 'customers-card'] , 'Liquidity': ['bi-list-ol', 'customers-card'] }


    return (
        <div className='flex justify-between items-center gap-2'>
            <div className={"w-1/4 card info-card " + ICON_HASH_FOR_SUMMERY['Price Change'][1]}>
                <div  className="card-body" style={{ overflow: "hidden" }}>
                    <h5 className="card-title p-2.5 mb-0">Price Change</h5>

                    <div className="d-flex align-items-center p-2.5" style={{ cursor: 'pointer' }} onClick={handleShowDrillDown}>
                            {/* <i className={"bi " + ICON_HASH_FOR_SUMMERY['Price Change'][0]}></i> */}
                       <div className='card-icon rounded-circle align-items-center justify-content-center'>

                        <MdOutlinePriceChange className='text-[28px]'  />
                       </div>     
                        <div className="ps-3 text-[28px] flex items-center gap-1">
                            <div className='text-[#012970]' style={{fontWeight: 700}}>{(diamondKeys.price_change?.toFixed(1))}</div>
                            <span className='text-xs'>%</span>
                        </div>
                    </div>
                </div>
            </div>
     
        
            <div className={"w-1/4 card info-card " + ICON_HASH_FOR_SUMMERY['% Sold'][1]}>
                <div  className="card-body" style={{ overflow: "hidden" }}>
                    <h5 className="card-title  p-2.5 mb-0">Sales Distribution</h5>

                    <div className="d-flex align-items-center p-2.5" style={{ cursor: 'pointer' }} onClick={handleShowDrillDown}>
                    <div className="card-icon rounded-circle align-items-center justify-content-center">
                            <IoPieChartOutline className='text-[28px]' />
                    </div>
                        <div className="ps-3 text-[28px] flex items-center gap-1">
                            <div className='text-[#012970]' style={{fontWeight: 700}}>{diamondKeys.sales_distribution}</div>
                            <span className='text-xs'>%</span>
                        </div>
                    </div>
                </div>
            </div>
      
        
            <div className={"w-1/4 px-6 card info-card  " + ICON_HASH_FOR_SUMMERY['Overhang'][1]}>
                <div  className="card-body" style={{ overflow: "hidden" }}>
                    <h5 className="card-title p-2.5 mb-0">Inventory Overhang</h5>

                    <div className="d-flex align-items-center p-2.5" style={{ cursor: 'pointer' }} onClick={handleShowDrillDown}>
                        <div className="card-icon rounded-circle align-items-center justify-content-center">
                            <i className={"text-[28px] bi " + ICON_HASH_FOR_SUMMERY['Overhang'][0]}></i>
                        </div>
                        <div className="ps-3 text-[28px] flex items-center gap-1">
                            <div className='text-[#012970]' style={{fontWeight: 700}}>{diamondKeys.overhang}</div>
                            <span className='text-xs'>days</span>
                        </div>
                    </div>
                </div>
            </div>
        
        
        
        
            {/* <div className={"w-1/4 card info-card " + ICON_HASH_FOR_SUMMERY['Liquidity'][1]}>
                <div  className="card-body" style={{ overflow: "hidden" }}>
                    <h5 className="card-title p-2.5 mb-0">Liquidity</h5>

                    <div className="d-flex align-items-center p-2.5" style={{ cursor: 'pointer' }} onClick={handleShowDrillDown}>
                        <div className="card-icon rounded-circle align-items-center justify-content-center">
                            <MdOutlineSpeed className='text-[28px]' />
                        </div>
                        <div className="ps-3 text-[28px] flex items-center gap-1">
                            <div className='text-[#012970]' style={{fontWeight: 700}}>{diamondKeys.liquidity}</div>
                            <span className='text-xs'>/10</span>
                        </div>
                    </div>
                </div>
            </div> */}
        
     </div> 
    )
}

export default MISummaryCard